import TagId from '~/constants/common/TagId';

export enum Dismissed {
  None = 0,
  Banner = 1
}

export enum PromoBanners {
  Geico,
  PriceDrop,
  Root,
  WSYS
}

export const NewPriceFilter = { tagIds: [TagId.PriceDrop.toString()] };
